import { dev } from '../../features/network/ApiCall';
import podImg1 from '../../assets/images/dnaImg1.webp';
import hubImg1 from '../../assets/images/hubImg1.webp';
import champImg1 from '../../assets/images/champImg1.webp';
import chronImg1 from '../../assets/images/chronImg1.webp';

export const YearList = ['2025'];

export const MonthsList: any = {
  '2025': [
    {
      month: 'October',
      key: 'oct25ed1'
      // editionList: [{ label: 'Edition 1', key: 'oct25ed1' }]
    }
  ]
};

export const IdList: any = {
  oct25ed1: ['2025', 'October', 'Edition1']
};

export const EventData: any = {
  oct25ed1: {
    title: 'Mahindra & Mahindra – Celebrating the heft of 80!',
    topImg: '',
    bottomImg: '',
    pod: {
      title: 'Podcast with the leaders on ethics',
      desc: 'In conversation with our Chairman Anand Mahindra on Mahindra’s evolution, culture and values',
      image: podImg1,
      // image: 'https://img.youtube.com/vi/dr6Kz3f5QlY?si=vkXqIG6Q-0z5QtAT/0.jpg',
      url: 'https://www.youtube.com/embed/dr6Kz3f5QlY?si=vkXqIG6Q-0z5QtAT'
    },
    chron: {
      title: 'Newsletter on real life case studies',
      desc: 'Read and understand from the PoSH cases around us',
      image: chronImg1,
      url: `${dev}/fileUpload/viewFile?file=20251014093250_Ethics_Chronicle_Awareness_building_PoSH_September.pdf`
    },
    hub: {
      title: 'Poster/ policy snippet',
      desc: `Learn about Mahindra's policies, practices and consequences of a breach`,
      image: hubImg1,
      url: `${dev}/fileUpload/viewFile?file=20251017110538_awareness_(1).pdf`
      // url: `${dev}/fileUpload/viewFile?file=20250930125902_Hindi.jpg`
    },
    champ: {
      title: 'Flag bearers of ethics',
      desc: 'Significance of the Ethics Counsellors program and their new initiatives',
      image: champImg1,
      // url: 'https://www.youtube.com/embed/9QG7WoTsiWg',
      url: 'https://streams.bitmovin.com/d3np4gr3f916mekeh3sg/embed',
      isVideo: true
    }
  },
  sept25ed1: {}
};
